import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';

import { useStores } from 'hooks/useStores';

interface IProps {
  advertItemType: string;
  excavatorType: string;
  tractionClass: number;
  loaderType: string;
}

const SpecialMachineType: FC<IProps> = observer(
  ({ advertItemType, excavatorType, tractionClass, loaderType }) => {
    const {
      dictionariesStore: { traction_classes, excavator_types, loader_types },
    } = useStores();

    const nameOfSubtype = [
      excavatorType && excavator_types[excavatorType],
      tractionClass && `${traction_classes[tractionClass]} тяговый класс`,
      loaderType && loader_types[loaderType],
    ]
      .filter((el) => el)
      .join(', ');

    return (
      <tr>
        <td className="pale">Тип</td>
        <td>
          <span className="bold break">{`${advertItemType}${nameOfSubtype ? ', ' : ''}`}</span>
          {!!nameOfSubtype && <div>{nameOfSubtype}</div>}
        </td>
      </tr>
    );
  },
);

export default SpecialMachineType;
